<div
  class="title__worker-type text-italic cur-pointer"
  [ngbPopover]="menuPopContent"
  placement="bottom-right"
  triggers="manual"
  #p2="ngbPopover"
  (click)="toggleWithMenuContext(p2)"
  id="topbarNatigationMenu"
>
  <app-icon [glyph]="'menu'" [size]="'22'" [color]="'blue-dark'"></app-icon>
</div>

<ng-template #menuPopContent>
  <div class="topbar__navigation">
    <div class="grid grid--gap-4 grid--va-middle mt-8 mb-8" *ngIf="authData.current_group['id'] === 1 || authData.current_group['id'] === 2">
      <div class="grid__box grid__box--size-min">
        <app-icon [glyph]="'monitoring'" [size]="'24'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <a class="link" routerLink="{{ '/' + SECTORS_PATHS.monitoring }}" id="sectorMonitoringLink">Мониторинг работы участков</a>
      </div>
    </div>
    <div class="grid grid--gap-4 grid--va-middle mt-8 mb-8" *ngIf="authData.current_group['id'] === 3">
      <div class="grid__box grid__box--size-min">
        <app-icon [glyph]="'clock'" [size]="'24'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <a class="link" routerLink="{{ '/' + WORK_SHIFT_PATHS.work_shift }}" id="workShiftLink">Смена</a>
      </div>
    </div>
    <div class="grid grid--gap-4 grid--va-middle mt-8 mb-8">
      <div class="grid__box grid__box--size-min">
        <app-icon [glyph]="'bell-main'" [size]="'24'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <a class="link" routerLink="{{ '/' + NOTIFICATIONS_PATHS.notifications }}" id="notificationsLink">Уведомления</a>
      </div>
    </div>
    <div class="grid grid--gap-4 grid--va-middle mt-8 mb-8" *ngIf="authData.current_group['id'] === 3">
      <div class="grid__box grid__box--size-min">
        <app-icon [glyph]="'graphic'" [size]="'24'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <a class="link" routerLink="{{ '/' + WORK_SHIFTS_PATHS.work_shifts }}" id="workShiftsLink">График рабочих смен</a>
      </div>
    </div>
    <div class="grid grid--gap-4 grid--va-middle mt-8 mb-8">
      <div class="grid__box grid__box--size-min">
        <app-icon [glyph]="'folder'" [size]="'24'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <a class="link" routerLink="{{ '/' + REFERENCES_PATHS.references }}" id="referencesLink">Справочники</a>
      </div>
    </div>
    <app-role-access [action]="'visible'" [permission]="'employee.add'">
      <div class="grid grid--gap-4 grid--va-middle mt-8 mb-8">
        <div class="grid__box grid__box--size-min">
          <app-icon [glyph]="'user-main'" [size]="'24'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
        </div>
        <div class="grid__box grid__box--size-min">
          <a class="link" routerLink="{{ '/' + USERS_PATHS.users_create }}" id="userCreateLink">Регистрация нового сотрудника</a>
        </div>
      </div>
    </app-role-access>
    <app-role-access [action]="'visible'" [permission]="'settings.get'">
      <div class="grid grid--gap-4">
        <div class="grid__box grid__box--size-min">
          <app-icon [glyph]="'menu'" [size]="'18'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
        </div>
        <div class="grid__box grid__box--size-min">
          <a class="link" routerLink="{{ '/' + APP_SETTINGS_PATHS.settings }}" id="appSettingsLink"> Настройки системы </a>
        </div>
      </div>
    </app-role-access>
  </div>
</ng-template>
